<!--
 * @Author: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @Date: 2025-02-16 21:08:11
 * @LastEditors: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @LastEditTime: 2025-08-05 10:57:28
 * @Description: 
-->
<template>
  <n-config-provider style="height: 100%;" :locale="locale" :date-locale="dateLocale">
    <n-dialog-provider>
      <RouterView />
    </n-dialog-provider>
  </n-config-provider>
</template>

<style scoped></style>

<script setup>
import { ref, onMounted } from 'vue'
import { dateZhCN, zhCN } from 'naive-ui'
import ribbon from './components/ribbon.js'
const message = ref('你好，wps加载项')

const locale = ref(null)
const dateLocale = ref(null)

onMounted(() => {
  window.ribbon = ribbon
  locale.value = zhCN;
  dateLocale.value = dateZhCN;
})
</script>
<style>
#app {
  height: 100vh;
  overflow: hidden;
  padding: 0 !important;
  color: #333;
  background: #f5f5f5;
}
</style>
